




















import { Component, Vue } from 'vue-property-decorator'

@Component({
  components: {}
})
export default class ScreenSaver extends Vue {
  public $refs!: {
    frontElement: HTMLElement
    backElement: HTMLElement
  }

  private timer?: number
  private imageTimer?: number
  private clearTimer?: number

  private front?: HTMLElement
  private back?: HTMLElement
  private timeout: number = 5 * 60000 // five minutes
  private fadeDuration: number = 2500
  private slideDuration: number = 10000
  private index: number = 0

  private isFront: boolean = true
  private hidden: boolean = true

  private screenSaverAnimations = [
    'ken-burns-bottom-right',
    'ken-burns-top-left',
    'ken-burns-bottom-left',
    'ken-burns-top-right',
    'ken-burns-middle-left',
    'ken-burns-middle-right',
    'ken-burns-top-middle',
    'ken-burns-bottom-middle',
    'ken-burns-center'
  ]

  private screenSaverImages = [
    { src: 'style/screensaver/01.jpg' },
    { src: 'style/screensaver/02.jpg' },
    { src: 'style/screensaver/03.jpg' },
    { src: 'style/screensaver/04.jpg' },
    { src: 'style/screensaver/05.jpg' },
    { src: 'style/screensaver/06.jpg' }
  ]

  private unBindEvents () {
    document.removeEventListener('mousedown', this.onDown)
    document.removeEventListener('touchend', this.onDown)
  }

  private bindEvents () {
    document.addEventListener('mousedown', this.onDown)
    document.addEventListener('touchend', this.onDown)
  }

  private onDown (e: MouseEvent | TouchEvent) {
    this.hidden = true
    this.createTimer(this.timeout)
  }

  private mounted () {
    this.bindEvents()
    this.createTimer(this.timeout)
  }

  private unmounted () {
    this.destroyTimers()
  }

  private destroyed () {
    this.unBindEvents()
  }

  private createTimer (delay: number) {
    this.destroyTimers()
    this.timer = setTimeout(() => {
      this.hidden = false
      this.createImageInterval()
    }, delay)
  }

  private destroyTimers () {
    clearTimeout(this.timer)
    clearInterval(this.imageTimer)
    if (this.front) {
      this.front.style.animationDirection = ''
      this.front.style.animationName = ''
      this.front.style.animationTimingFunction = ''
      this.front.style.animationDuration = ''
    }
    if (this.back) {
      this.back.style.animationDirection = ''
      this.back.style.animationName = ''
      this.back.style.animationTimingFunction = ''
      this.back.style.animationDuration = ''
    }
  }

  private createImageInterval () {
    this.imageTimer = setInterval(() => {
      this.isFront = !this.isFront
      this.index++
      if (this.index >= this.screenSaverImages.length) {
        this.index = 0
      }
      this.setNextImage(this.index)
    }, this.slideDuration - this.fadeDuration)

    this.setNextImage(0)
  }

  private setNextImage (index: number) {
    // get random animation
    const random = Math.random()
    const animationIndex = Math.floor(random * this.screenSaverAnimations.length)

    if (this.isFront) {
      this.front = this.$refs.frontElement
      this.back = this.$refs.backElement
    } else {
      this.front = this.$refs.backElement
      this.back = this.$refs.frontElement
    }
    if (this.front) {
      const image = this.front.getElementsByTagName('img')[0]
      image.src = this.$theme() + this.screenSaverImages[index].src
      this.front.style.animationDirection = 'normal'
      this.front.style.animationName = this.screenSaverAnimations[animationIndex] + ', fade-in'
      this.front.style.animationTimingFunction = 'linear, ease'
      this.front.style.animationDuration = this.slideDuration + 'ms,' + this.fadeDuration + 'ms'
      this.front.style.zIndex = '1'
      this.back.style.zIndex = '0'
    }

    this.clearPreviousImage(this.back)
  }

  private clearPreviousImage (element: HTMLElement) {
    this.clearTimer = setTimeout(() => {
      element.getElementsByTagName('img')[0].src = ''
      element.style.animationDirection = ''
      element.style.animationName = ''
      element.style.animationTimingFunction = ''
      element.style.animationDuration = ''
    }, this.fadeDuration)
  }
}
